import { gql } from '@apollo/client';

/**
 * Template GraphQL Fragment - All 41 fields (31 core + 6 formula + 4 append-only)
 */
export const TEMPLATE_FIELDS_FRAGMENT = gql`
  fragment TemplateFields on Template {
    # Identity (5 fields)
    id
    tenantId
    name
    version
    description

    # Metadata DSL (4 layers)
    businessLayer
    uiLayer
    primitiveLayer
    mappingsLayer

    # Template Management (5 fields)
    status
    parentTemplateId
    category
    tags
    usageCount

    # Approval & Validation (5 fields)
    validationResult
    approvalWorkflowId
    publishedBy
    publishedAt
    confidenceScore

    # Regulatory & Compliance (9 fields)
    complianceFrameworks
    criticality
    authorityId
    complianceLevel
    auditRequirements
    jurisdictionalScope
    effectiveDate
    expirationDate
    riskClassification

    # Metadata & Extensibility (2 fields)
    metadata
    active

    # Formula Tracking (6 fields)
    targetFormulas
    generatedInstanceIds
    formulaSuccessRates
    formulasParticipating
    lastGeneratedAt
    generationCount

    # Append-Only Architecture (4 fields)
    parentVersionId
    originalId
    recordVersion
    isActive

    # Audit fields (5 fields)
    createdAt
    updatedAt
    createdBy
    updatedBy
    auditVersion
  }
`;
